import apiClient from './client'

export const offersApi = {
  getAll: (params?: Record<string, unknown>) =>
    apiClient.get('/offers', { params }).then((r) => r.data),
  getById: (id: string) =>
    apiClient.get(`/offers/${id}`).then((r) => r.data),
  create: (data: Record<string, unknown>) =>
    apiClient.post('/offers', data).then((r) => r.data),
  update: (id: string, data: Record<string, unknown>) =>
    apiClient.put(`/offers/${id}`, data).then((r) => r.data),
  delete: (id: string) =>
    apiClient.delete(`/offers/${id}`),

  accept: (id: string) =>
    apiClient.post(`/offers/${id}/accept`).then((r) => r.data),
  reject: (id: string, reason: string) =>
    apiClient.post(`/offers/${id}/reject`, { reason }).then((r) => r.data),
  counter: (id: string, newAmount: number, conditions?: string) =>
    apiClient.post(`/offers/${id}/counter`, { newAmount, conditions }).then((r) => r.data),
}
